import React from "react";

import Text from "src/components/text";
import { getAuthorName, formatTimespent } from "src/services/reports.service";

import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

import _ from "lodash";
import styles from "./styles.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface TopSharedAssetListCardProps {
  item: {
    asset: Asset;
    analytics: Analytics;
  };
  columnCount: number;
}

export const TopSharedAssetListCard: React.FC<TopSharedAssetListCardProps> = ({
  item,
  columnCount,
}) => {
  const { asset, analytics } = item;

  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={asset?.icon?.thumbnail || DefaultAssetIcon}
          alt={asset.name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/assets/${asset.id}?source=reports`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text lines={1} className={styles.title} text={asset?.name} />
            </div>
            <div className={styles.metaData}>
              Author:{" "}
              <Text
                text={asset.author ? getAuthorName(asset.author) : ""}
                lines={1}
                className={styles.author}
              />
            </div>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.shares}</div>
        <div className={styles.tableDataViews}>{analytics.views}</div>
        <div className={styles.tableDataViews}>{analytics.totalReactionsCount}</div>
        <div className={styles.tableDataTime}>
          {formatTimespent(_.get(analytics, "avgTimeSpent", 0))}
        </div>
        <div className={styles.tableDataTime}>
          {formatTimespent(_.get(analytics, "totalTimeSpent", 0))}
        </div>
        <div className={styles.tableDataViews}>{analytics.downloads}</div>
        <div className={styles.tableDataShares}>{analytics.totalCommentsCount}</div>
      </div>
    </div>
  );
};
